import React from 'react';
import { Container,Row,Col,Card,Carousel,Image } from 'react-bootstrap';
const DevPage = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    return (
        <section className="bg-white hp-about">
            <Container className="py-7">
                <Row className="g-0 align-items-center justify-content-end position-relative border-0">
                    <Col md={6} className="position-absolute start-0 z-1">
                        <Card className="border-0 shadow">
                            <Card.Body>
                                <div className="border-success border p-3 text-start">
                                    <h2 className="text-danger text-uppercase">404 <span className="text-primary">{appLanguage === 'hi' ? "पेज" : "PAGE"}</span></h2>
                                    <span className="bg-success mb-4 sub-heading"></span>
                                    <h5 className='text-danger'>{appLanguage === 'hi' ? "पेज नहीं मिला" : "PAGE NOT FOUND"}</h5>
                                    <p className="text-justify mb-4">{appLanguage === 'hi' ? "आप जिस पेज को खोज रहे हैं, उसे शायद हटा दिया गया है। या तो उसका नाम बदल दिया गया है या फिर वह अस्थायी रूप से अनुपलब्ध है।" : "The page you are looking for might have been removed. Either had its name changed or temporarily unavailable."}</p>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col md={7}>
                        <Card data-aos="fade-left" data-aos-duration="1500">
                            <Carousel id='bs-slider' >
                                <Carousel.Item>
                                    <Image src={global.config.uploadPath+'600705579.jpg'} fluid width={732} height={488} alt={appLanguage === 'hi' ? 'आईजीडीटीयूडब्लू प्रवेश द्वार फोटो' : 'IGDTUW Entry Gate'} />                        
                                </Carousel.Item>                                
                                <Carousel.Item>
                                    <Image src={global.config.uploadPath+'600705579.jpg'} fluid width={732} height={488} alt={appLanguage === 'hi' ? 'आईजीडीटीयूडब्लू प्रवेश द्वार धारक के रूप में' : 'IGDTUW Entry Gate as holder'} />
                                    <div className="carousel-caption d-block d-print-none">
                                        <div className="ratio ratio-4x3">
                                            <iframe title={appLanguage === 'hi' ? 'आईजीडीटीयूडब्लू लाइफ यूट्यूब वीडियो' : 'IGDTUW Life Youtube Video'} src="https://www.youtube.com/embed/alyJeRLX7Pg?rel=0&cc_load_policy=1" allowFullScreen="allowfullscreen"></iframe>
                                        </div>
                                    </div>
                                </Carousel.Item>   
                            </Carousel>                        
                        </Card>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}
export default DevPage;